<template>
  <div>
    <a-form-model  layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
      <a-form-model-item  label='公式类型' prop='type' >
        <a-radio-group v-model="model.type" size="small">
          <a-radio-button value="1">
            量表计算
          </a-radio-button>
          <a-radio-button value="2">
            数据填入
          </a-radio-button>
          <a-radio-button value="3">
            级联填入
          </a-radio-button>
          <a-radio-button value="4">
            周期计算
          </a-radio-button>
          <!--<a-radio-button value="4">-->
            <!--测评结果-->
          <!--</a-radio-button>-->
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item  label='排序' prop='sortNum' >
        <a-input-number v-model="model.sortNum" placeholder="请输入排序" :min="0" :precision="0" style="width: 100px"/>
      </a-form-model-item>
      <template v-if="model.type === '1' || model.type === '2' || model.type === '3'">
        <a-form-model-item  label='公式更新表单' prop='formId' >
          <a-select v-model='model.formId' placeholder='请选择公式更新表单' @change="formIdChange()" showSearch :filterOption="filterOptionTip">
            <a-select-option :value='item.id' :key="item.id" v-for="item in formList">
              <a-tooltip :title="item.description" placement="right">
                {{item.name}}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item  label='公式更新元素' prop='formItemId' >
          <a-select v-model='model.formItemId' placeholder='请选择公式更新元素' @change="formItemIdChange" showSearch :filterOption="filterOption" >
            <a-select-option :value='item.id' :key="item.id" v-for="item in formItemList">{{(item.number?item.number:"") + item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
      <template v-if="model.type === '4'">
        <a-form-model-item  label='公式更新周期' prop='formId' >
          <a-select v-model='periodIds' placeholder='请选择公式更新周期' @change="periodIdChange()" showSearch allow-clear mode="multiple" :filterOption="filterOption">
            <a-select-option :value='item.id' :key="item.id" v-for="item in periodItemList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item  label='公式更新元素' prop='formItemId' >
          <a-select v-model='model.formItemId' placeholder='请选择公式更新元素' showSearch allow-clear :filterOption="filterOption" >
            <a-select-option :value='item.id' :key="item.id" v-for="item in periodFieldList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
    </a-form-model>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
import Template from '../Template.vue'
export default {
  components: { Template },
  name: 'Step1',
  data() {
    return {
      rules: {
        formId:[baseRules.requiredChange],
        formItemId:[baseRules.requiredChange],
        sortNum:[baseRules.required],
        type:[baseRules.requiredChange],
      },
      formList:[],
      periodItemList: [],//周期
      formItemList:[],
      model:{},
      periodFieldList: [{"id":"baseDate","name":"周期基点日期"}],
      periodIds: [],
    }
  },
  created() {


  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))
      getAction('/project/projectForm/listAll',{projectId:this.model.projectId}).then(res=>{
        if(res.success){
          this.formList=res.result
        }
      })
      getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
      this.formIdChange(true)
      if(this.model.type==='4'){
        if (this.model.formId){
          if(this.model.formId.endsWith(',')) {
            this.model.formId = this.model.formId.slice(0, -1)            
          }
          this.periodIds = this.model.formId.split(',')
        }        
      }
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.ruleForm.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    },
    formItemIdChange(){
      let formItem = null
      if(this.model.formItemId){
        getAction('/project/projectFormItem/queryById',{id:this.model.formItemId}).then(res=>{
          if(res.success){
            formItem = res.result
            this.$set(this.model,'formItem',formItem)
          }
        })
      }
      else{
        formItem = null
        this.$set(this.model,'formItem',formItem)
      }
    },
    formIdChange(edit){
      this.formItemList = []
      if(this.model.formItemId && !edit){
        this.model.formItemId = null
      }
      if(this.model.formId){
        getAction('/project/projectFormItem/listAll',{formId:this.model.formId}).then(res=>{
          if(res.success){
            this.formItemList = res.result
            this.formItemIdChange()
          }
        })
      }
    },
    periodIdChange(){
      if(this.periodIds && this.periodIds.length>0){
        this.model.formId = this.periodIds.join(',')
      }else{
        this.model.formId = ''
      }
      console.log("this.model.formId:"+ this.model.formId)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterOptionTip(input, option) {
      return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>

<style scoped>

</style>
